<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="90px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="单号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.irCode"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="工厂编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.site"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :lg="5" :xl="5">
          <el-form-item label="通道编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.whCode"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="库位编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.location"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.item"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
         <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getTableData">查询</el-button>
            <el-button class="btn-t-delete" @click="reset">重置</el-button>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料批次" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.batchLot"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker v-model="mainSearch.date[0]" @change="saveSearch()" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="结束日期" class="EL-Form-Item">
              <el-date-picker v-model="mainSearch.date[1]" @change="saveSearch()" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
        </el-col> -->
      </el-form>
    </box>
    <box fill>
      <plabel text="库存对比差异列表">
        <el-button
          v-authority="'BACK_MENU3_M22_B1'"
          :loading="xaloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="synXaInventory()"
          >同步XA</el-button
        >
        <el-button
          v-authority="'BACK_MENU3_M22_B2'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <h-table
        :headerCellStyle="mainData.headerCellStyle"
        style="flex: 1"
        @pageChange="getTableData"
        :data="mainData.data"
        pagination
        :nowPage.sync="mainData.nowPage"
        :pageSize.sync="mainData.pageSize"
        :total.sync="mainData.total"
      >
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column
          label="单号"
          align="center"
          prop="irCode"
        ></el-table-column>
        <el-table-column
          label="工厂编号"
          align="center"
          prop="site"
        ></el-table-column>
        <el-table-column
          label="通道编号"
          align="center"
          prop="whCode"
        ></el-table-column>
        <el-table-column
          label="库位编号"
          align="center"
          prop="location"
        ></el-table-column>
        <el-table-column
          label="物料编号"
          align="center"
          prop="item"
        ></el-table-column>
        <el-table-column
          label="物料批次"
          align="center"
          prop="batchLot"
        ></el-table-column>
        <el-table-column
          label="XA数量"
          align="center"
          prop="quantityOnhand"
        ></el-table-column>
        <el-table-column
          label="WMS数量"
          align="center"
          prop="wmsQuan"
        ></el-table-column>
        <el-table-column label="入库时间" align="center" prop="fifoDate"></el-table-column>
		<el-table-column
          label="创建时间"
          align="center"
          prop="createTime"
        ></el-table-column>
        <el-table-column
          label="更新时间"
          align="center"
          prop="updateTime"
        ></el-table-column>
        <el-table-column label="是否完成" align="center" prop="dealFlag">
          <template slot-scope="scope">
            <div v-if="scope.row.dealFlag" style="color: red">Y</div>
            <div v-if="!scope.row.dealFlag">N</div>
          </template>
        </el-table-column>
        <el-table-column label="原因" align="center" prop="dealFlag" width="200px">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.dealReason"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <el-button class="btn-t-detail" @click="detailDialog(scope.row)"
            v-authority="'BACK_MENU3_M22_B3'"
              >详情</el-button
            >
            <el-button
              class="btn-t-detail"
              @click="updateStatus(scope.row)"
              v-authority="'BACK_MENU3_M22_B4'"
              >完成</el-button
            >
          </template>
        </el-table-column>
      </h-table>
    </box>

    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="detailDialogShow"
      class="infoDialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <el-row
          style="
            text-align: left;
            height: 45px;
            line-height: 45px;
            background-color: #2196f324;
          "
        >
          <el-col :span="4">对比单号：{{ dataDetails.data.irCode }}</el-col>
          <el-col :span="4">工厂编号：{{ dataDetails.data.site }}</el-col>
          <el-col :span="4">通道编号：{{ dataDetails.data.whCode }}</el-col>
          <el-col :span="4">货位编号：{{ dataDetails.data.location }}</el-col>
          <el-col :span="4">物料编号：{{ dataDetails.data.item }}</el-col>
          <el-col :span="4">物料批次：{{ dataDetails.data.batchLot }}</el-col>
        </el-row>
        <hr />
      </div>
      <div>
        <div style="width: 28%; float: left">
          <p>XA库存</p>
          <h-table
            :headerCellStyle="dataDetails.headerCellStyle"
            style="height: 46vh"
            :data="dataDetails.xaList"
          >
            <el-table-column
              label="数量"
              align="center"
              prop="quantityOnhand"
            ></el-table-column>
            <el-table-column label="入库时间" align="center" prop="fifoDate"></el-table-column>
            <el-table-column label="操作" align="center" prop="fifoDate">
              <template slot-scope="scope">
                  <el-button class="btn-t-detail" @click="insertXaWhInventory(scope.row)"
                >添加库存</el-button>
              </template>
            </el-table-column>
          </h-table>
        </div>
        <div style="width: 68%; float: left; margin-left: 2%">
          <p>WMS库存</p>
          <h-table
            :headerCellStyle="dataDetails.headerCellStyle"
            style="height: 46vh"
            :data="dataDetails.whList"
          >
            <el-table-column
              label="物料名称"
              align="center"
              prop="matName"
            ></el-table-column>
            <el-table-column
              label="箱号"
              align="center"
              prop="boxBarcode"
            ></el-table-column>
            <el-table-column label="总数量" align="center" prop="matQuan">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.matQuan"
                  :min="0"
                  style="width: 100%; line-height: 26px !important"
                  size="mini"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="已分配数量"
              align="center"
              prop="matDistrQuan"
            ></el-table-column>
            <el-table-column
              label="入库时间"
              align="center"
              prop="matCreateTime"
            ></el-table-column>
            <el-table-column label="状态" align="center" prop="wiStatus">
              <template slot-scope="scope">
                <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
              </template>
            </el-table-column>
            <el-table-column label="调整数量为" align="center">
              <template slot-scope="scope">
                {{ scope.row.matQuan - scope.row.matDistrQuan }}
              </template>
            </el-table-column>
          </h-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogClose" type="info">取 消</el-button>
        <el-button @click="updateWMSQuan()" type="primary"
          >调整WMS数量</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "WhInventoryXaRecord",
  data() {
    return {
      warehouseList: [],
      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 50,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      // 筛选条件
      mainSearch: {
        irCode: "",
        site: "",
        whCode: "",
        location: "",
        item: "",
        batchLot: "",
        date: [],
      },
      //详情
      detailDialogShow: false,
      dataDetails: {
        data: {},
        xaList: [],
        whList: [],
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,

      //同步XA
      xaloadLoading: false, //同步中

      irId: '',
    };
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
    chooseDictDataList: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.date[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.date[1]);
          }
        },
      };
    },
  },
  activated() {
    /* 获取首页的数据 */
    this.getTableData();
  },
  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getTableData();
      }, 1000);
    },
    /**
     * 重置
     */
    reset() {
      this.mainSearch = {
        irCode: "",
        site: "",
        whCode: "",
        location: "",
        item: "",
        batchLot: "",
        date: [],
      };
    },
    /**
     * 获取列表
     */
    getTableData() {
      this.$http
        .request({
          url: "/api/whXaRecord/getAllData",
          method: "GET",
          params: {
            pageNum: this.mainData.nowPage, //	页号
            pageSize: this.mainData.pageSize, //	页大小
            irCode: this.mainSearch.irCode || null,
            //site: this.mainSearch.site || null,
            site: localStorage.getItem("fcCode"),
            whCode: this.mainSearch.whCode || null,
            location: this.mainSearch.location || null,
            item: this.mainSearch.item || null,
            batchLot: this.mainSearch.batchLot || null,
            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.mainData.data = res.data.list;
            this.mainData.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },
    /**
     * 详情
     */
    detailDialog(row) {
      this.detailDialogShow = true;
      this.dataDetails.data = row;
      this.getWhXaDetails(row.irId);
    },
    detailDialogClose() {
      this.detailDialogShow = false;
      this.dataDetails.data = {};
      this.dataDetails.xaList = [];
      this.dataDetails.whList = [];
    },
    getWhXaDetails(irId) {
      this.irId = irId;
      this.$http
        .request({
          url: "/api/whXaRecord/getWhXaDetails",
          method: "GET",
          params: {
            irId: irId,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.dataDetails.xaList = res.data.xaList || [];
            this.dataDetails.whList = res.data.whList || [];
          } else {
            this.$message.error("错误");
          }
        });
    },
    updateWMSQuan() {
      if (this.dataDetails.whList.length > 0) {
        this.$http
          .request({
            url: "/api/whXaRecord/updateWmsQuan",
            method: "POST",
            data: this.dataDetails.whList,
          })
          .then((res) => {
            if (res.status == 100) {
              this.detailDialogClose();
            } else {
              this.$message.error("错误");
            }
          });
      } else {
        this.detailDialogClose();
      }
    },
    updateStatus(data) {

      if(data.dealReason == undefined){

        data.dealReason = '';

      }

      this.$http
        .request({
          url: "/api/whXaRecord/updateStatus",
          method: "PUT",
          params: {
            irId: data.irId,
            reason: data.dealReason,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message.error("错误");
          }
        });
    },
    insertXaWhInventory(data){
      this.$http
        .request({
          url: "/api/whXaRecord/insertXaWh",
          method: "POST",
          data: data,
          params: {
            irId: this.irId
          }
        })
        .then((res) => {
          if (res.status == 100) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.getWhXaDetails(this.irId);
          } else {
            this.$message.error("错误");
          }
        });

    },

    /**
     * 同步XA
     *  1. 网页端提交同步信息，2.开始同步库存。 3. 等同步完成后进行对比， 4. 对比结果网页中查看， 5. 对比的数据进行处理。
     */
    synXaInventory() {
      console.log("1111");
      this.xaloadLoading = true;
      this.$http
        .request({
          url: "/api/whXaRecord/synXaInventory",
          method: "GET",
          params: {},
        })
        .then((resp) => {

          if(resp.status == 100){
            this.$message({
              message: resp.message,
              type: "success",
            });
          }else{
            this.$message({
              message: resp.message,
              type: "error",
            });
          }
          this.xaloadLoading = false;
        })
        .catch((error) => {
          this.xaloadLoading = false;
        });
      console.log("2222");
      this.xaloadLoading = false;
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        irCode: this.mainSearch.irCode || null,
        site: localStorage.getItem("fcCode"),
        whCode: this.mainSearch.whCode || null,
        location: this.mainSearch.location || null,
        item: this.mainSearch.item || null,
        batchLot: this.mainSearch.batchLot || null,
        beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
        endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/whXaRecord/getAllData",
          method: "GET",
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function (c) {
          if (c.dealFlag) {
            c["dealFlag"] = "是";
          } else {
            c["dealFlag"] = "否";
          }
        });
        const tHeader = [
          "单号",
          "工厂编号",
          "通道编号",
          "库位编号",
          "物料编号",
          "物料批次",
          "XA数量",
          "WMS数量",
          "入库时间",
          "创建时间",
          "更新时间",
          "是否完成",
          "原因",
        ];
        const filterVal = [
          "irCode",
          "site",
          "whCode",
          "location",
          "item",
          "batchLot",
          "quantityOnhand",
          "wmsQuan",
          "fifoDate",
          "createTime",
          "updateTime",
          "dealFlag",
          "dealReason",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "库存对比记录单",
        });
        this.logContent = "导出";
        this.logRemarks = "wh_inventory：导出库存对比记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "库存记录",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          showLoading: true,
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
.div {
  width: 95%;
  height: 100%;
  margin-left: 30px;
  margin-bottom: 100px;
  text-align: center;
}

.div table th {
  width: 100px;
  height: 30px;
  border: 1px solid black;
  background: rgb(201, 197, 197);
  color: rgb(14, 13, 13);
}

.div table td {
  width: 100px;
  height: 30px;
  /* border: 1px solid black; */
  color: rgb(14, 13, 13);
}

.div1 {
  width: 300px;
  height: 40px;
  /* border: 1px solid black; */
  text-align: left;
  color: rgb(14, 13, 13);
  font-weight: bold;
  margin-left: 50px;
}
</style>